/* UltraNiche · world atmosphere engine
   Eight particle atmospheres (dust, snow, bubbles, fireflies, stars, petals, mist, neon),
   cursor spotlight, and velocity-reactive particle displacement.
   Gates: html.motion-on, prefers-reduced-motion. One shared rAF; stages only run near
   the viewport (IntersectionObserver) and pause when the tab is hidden. */
(function () {
  "use strict";
  if (window.__unAtmosInit) return; window.__unAtmosInit = true;

  var html = document.documentElement;
  var REDUCE = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  if (!html.classList.contains("motion-on") || REDUCE) return;
  var FINE = window.matchMedia && window.matchMedia("(hover:hover) and (pointer:fine)").matches;
  var SMALL = window.matchMedia && window.matchMedia("(max-width:920px)").matches;
  var DPR = Math.min(window.devicePixelRatio || 1, 1.75);
  var INTENSITY = 1;
  if (document.body) {
    INTENSITY = Math.max(0.3, Math.min(2, parseInt(document.body.getAttribute("data-un-intensity") || "60", 10) / 60));
  }

  /* ---------- pointer with velocity ---------- */
  var ptr = { x: -9999, y: -9999, vx: 0, vy: 0, lx: 0, ly: 0, lt: 0, speed: 0 };
  if (FINE) {
    window.addEventListener("pointermove", function (e) {
      if (e.pointerType === "touch") return;
      var t = performance.now(), dt = Math.max(t - ptr.lt, 1);
      ptr.vx = (e.clientX - ptr.lx) / dt * 16; ptr.vy = (e.clientY - ptr.ly) / dt * 16;
      ptr.speed = Math.min(Math.sqrt(ptr.vx * ptr.vx + ptr.vy * ptr.vy), 60);
      ptr.lx = e.clientX; ptr.ly = e.clientY; ptr.lt = t;
      ptr.x = e.clientX; ptr.y = e.clientY;
    }, { passive: true });
  }

  function rnd(a, b) { return a + Math.random() * (b - a); }
  function hx(h) {
    h = (h || "#ffffff").replace("#", "");
    if (h.length === 3) h = h[0] + h[0] + h[1] + h[1] + h[2] + h[2];
    var n = parseInt(h, 16); if (isNaN(n)) n = 16777215;
    return [(n >> 16) & 255, (n >> 8) & 255, n & 255];
  }
  function rgba(c, a) { return "rgba(" + c[0] + "," + c[1] + "," + c[2] + "," + a.toFixed(3) + ")"; }
  function mix(c, w, t) { return [Math.round(c[0] + (w[0] - c[0]) * t), Math.round(c[1] + (w[1] - c[1]) * t), Math.round(c[2] + (w[2] - c[2]) * t)]; }
  var WHITE = [255, 255, 255];

  /* ---------- modes: spawn + step + draw ----------
     Every particle: x,y (canvas px), vx,vy, r, a (alpha), tw (twinkle phase), rot, vr */
  var MODES = {
    dust: { density: 1.35, make: function (W, H, c) { return { x: rnd(0, W), y: rnd(0, H), vx: rnd(0.06, 0.3) * DPR, vy: rnd(-0.06, 0.06) * DPR, r: rnd(0.9, 3.0) * DPR, a: rnd(0.12, 0.5), tw: rnd(0, 6.28), col: mix(c, [232, 192, 122], 0.7) }; },
      step: function (p, W, H) { p.x += p.vx; p.y += p.vy + Math.sin(p.tw) * 0.05; p.tw += 0.015; if (p.x > W + 8) { p.x = -8; p.y = rnd(0, H); } },
      draw: function (g, p) { g.fillStyle = rgba(p.col, p.a * (0.7 + 0.3 * Math.sin(p.tw * 2))); g.beginPath(); g.arc(p.x, p.y, p.r, 0, 6.283); g.fill(); } },

    snow: { density: 1.25, make: function (W, H) { return { x: rnd(0, W), y: rnd(-H, H), vx: 0, vy: rnd(0.25, 0.8) * DPR, r: rnd(1.2, 4.0) * DPR, a: rnd(0.3, 0.85), tw: rnd(0, 6.28) }; },
      step: function (p, W, H) { p.tw += 0.012; p.x += Math.sin(p.tw) * 0.35 * DPR; p.y += p.vy; if (p.y > H + 6) { p.y = -6; p.x = rnd(0, W); } if (p.x < -6) p.x = W + 6; if (p.x > W + 6) p.x = -6; },
      draw: function (g, p) { g.fillStyle = rgba(WHITE, p.a); g.beginPath(); g.arc(p.x, p.y, p.r, 0, 6.283); g.fill(); } },

    bubbles: { density: 0.8, make: function (W, H, c) { return { x: rnd(0, W), y: rnd(0, H * 1.4), vx: 0, vy: rnd(-0.55, -0.18) * DPR, r: rnd(2.4, 8.0) * DPR, a: rnd(0.2, 0.55), tw: rnd(0, 6.28), col: mix(c, WHITE, 0.55) }; },
      step: function (p, W, H) { p.tw += 0.02; p.x += Math.sin(p.tw) * 0.3 * DPR; p.y += p.vy; if (p.y < -8) { p.y = H + 8; p.x = rnd(0, W); } },
      draw: function (g, p) { g.strokeStyle = rgba(p.col, p.a); g.lineWidth = 1 * DPR; g.beginPath(); g.arc(p.x, p.y, p.r, 0, 6.283); g.stroke(); g.fillStyle = rgba(WHITE, p.a * 0.35); g.beginPath(); g.arc(p.x - p.r * 0.3, p.y - p.r * 0.3, p.r * 0.25, 0, 6.283); g.fill(); } },

    fireflies: { density: 0.55, make: function (W, H, c) { return { x: rnd(0, W), y: rnd(0, H), vx: rnd(-0.2, 0.2) * DPR, vy: rnd(-0.2, 0.2) * DPR, r: rnd(1.8, 3.6) * DPR, a: rnd(0.4, 0.9), tw: rnd(0, 6.28), col: mix(c, [255, 244, 160], 0.45) }; },
      step: function (p, W, H) { p.tw += 0.03; p.vx += rnd(-0.02, 0.02) * DPR; p.vy += rnd(-0.02, 0.02) * DPR; p.vx = Math.max(-0.35 * DPR, Math.min(0.35 * DPR, p.vx)); p.vy = Math.max(-0.35 * DPR, Math.min(0.35 * DPR, p.vy)); p.x += p.vx; p.y += p.vy; if (p.x < 0) p.x = W; if (p.x > W) p.x = 0; if (p.y < 0) p.y = H; if (p.y > H) p.y = 0; },
      draw: function (g, p) { var glow = 0.25 + 0.75 * Math.pow(Math.max(Math.sin(p.tw), 0), 2); g.fillStyle = rgba(p.col, p.a * glow * 0.25); g.beginPath(); g.arc(p.x, p.y, p.r * 3.2, 0, 6.283); g.fill(); g.fillStyle = rgba(p.col, p.a * glow); g.beginPath(); g.arc(p.x, p.y, p.r, 0, 6.283); g.fill(); } },

    stars: { density: 1.2, make: function (W, H, c) { return { x: rnd(0, W), y: rnd(0, H), vx: 0.015 * DPR, vy: 0, r: rnd(0.8, 2.4) * DPR, a: rnd(0.25, 0.9), tw: rnd(0, 6.28), col: mix(c, WHITE, 0.75) }; },
      step: function (p, W, H) { p.tw += 0.025; p.x += p.vx; if (p.x > W + 4) p.x = -4; },
      draw: function (g, p) { g.fillStyle = rgba(p.col, p.a * (0.35 + 0.65 * Math.abs(Math.sin(p.tw)))); g.beginPath(); g.arc(p.x, p.y, p.r, 0, 6.283); g.fill(); } },

    petals: { density: 0.5, make: function (W, H, c) { return { x: rnd(0, W), y: rnd(-H, H), vx: rnd(0.1, 0.35) * DPR, vy: rnd(0.25, 0.6) * DPR, r: rnd(3.6, 7.5) * DPR, a: rnd(0.35, 0.75), tw: rnd(0, 6.28), rot: rnd(0, 6.28), vr: rnd(-0.03, 0.03), col: mix(c, WHITE, 0.3) }; },
      step: function (p, W, H) { p.tw += 0.015; p.rot += p.vr; p.x += p.vx + Math.sin(p.tw) * 0.4 * DPR; p.y += p.vy; if (p.y > H + 10) { p.y = -10; p.x = rnd(0, W); } if (p.x > W + 10) p.x = -10; },
      draw: function (g, p) { g.save(); g.translate(p.x, p.y); g.rotate(p.rot); g.fillStyle = rgba(p.col, p.a * (0.75 + 0.25 * Math.sin(p.tw * 2))); g.beginPath(); g.ellipse(0, 0, p.r, p.r * 0.55, 0, 0, 6.283); g.fill(); g.restore(); } },

    mist: { density: 0.1, make: function (W, H) { return { x: rnd(0, W), y: rnd(H * 0.25, H), vx: rnd(0.05, 0.22) * DPR, vy: rnd(-0.02, 0.02) * DPR, r: rnd(90, 210) * DPR, a: rnd(0.04, 0.1), tw: rnd(0, 6.28) }; },
      step: function (p, W, H) { p.tw += 0.006; p.x += p.vx; p.y += p.vy + Math.sin(p.tw) * 0.06; if (p.x - p.r > W) p.x = -p.r; },
      draw: function (g, p) { var grd = g.createRadialGradient(p.x, p.y, 0, p.x, p.y, p.r); grd.addColorStop(0, rgba(WHITE, p.a)); grd.addColorStop(1, rgba(WHITE, 0)); g.fillStyle = grd; g.beginPath(); g.arc(p.x, p.y, p.r, 0, 6.283); g.fill(); } },

    neon: { density: 0.7, make: function (W, H, c) { return { x: rnd(0, W), y: rnd(0, H * 1.3), vx: rnd(-0.08, 0.08) * DPR, vy: rnd(-1.4, -0.5) * DPR, r: rnd(1.2, 2.4) * DPR, a: rnd(0.3, 0.85), tw: rnd(0, 6.28), col: mix(c, WHITE, 0.2), len: rnd(6, 16) * DPR }; },
      step: function (p, W, H) { p.tw += 0.02; p.x += p.vx; p.y += p.vy; if (p.y < -20) { p.y = H + 20; p.x = rnd(0, W); } },
      draw: function (g, p) { var a = p.a * (0.6 + 0.4 * Math.sin(p.tw * 3)); g.strokeStyle = rgba(p.col, a); g.lineWidth = p.r; g.lineCap = "round"; g.beginPath(); g.moveTo(p.x, p.y); g.lineTo(p.x - p.vx * p.len, p.y - p.vy * p.len); g.stroke(); } }
  };

  /* ---------- stages ---------- */
  var stages = [];
  function setupStage(el) {
    if (el.__unAtmos) return; el.__unAtmos = true;
    var mode = MODES[el.getAttribute("data-atmos")] || MODES.dust;
    var col = hx(el.getAttribute("data-atmos-color"));
    var density = (parseInt(el.getAttribute("data-atmos-density") || "80", 10) / 100) * (SMALL ? 0.6 : 1);
    var cv = document.createElement("canvas");
    cv.className = "unw-atmos"; cv.setAttribute("aria-hidden", "true");
    el.insertBefore(cv, el.querySelector(".unw-grid"));
    var spot = null;
    if (el.hasAttribute("data-spot") && FINE) {
      spot = document.createElement("div");
      spot.className = "unw-spot"; spot.setAttribute("aria-hidden", "true");
      el.insertBefore(spot, el.querySelector(".unw-grid"));
    }
    var s = { el: el, cv: cv, g: cv.getContext("2d"), mode: mode, col: col, density: density,
              parts: [], W: 0, H: 0, active: false, spot: spot, sx: 0, sy: 0, sOn: false };
    s.size = function () {
      var r = el.getBoundingClientRect();
      s.W = cv.width = Math.max(1, Math.ceil(r.width * DPR));
      s.H = cv.height = Math.max(1, Math.ceil(r.height * DPR));
      var n = Math.round((s.W * s.H) / (15000 * DPR * DPR) * s.mode.density * s.density);
      n = Math.max(10, Math.min(n, 260));
      s.parts = []; for (var i = 0; i < n; i++) s.parts.push(s.mode.make(s.W, s.H, s.col));
    };
    s.size();
    stages.push(s);
  }
  document.querySelectorAll("[data-atmos]").forEach(setupStage);
  if (!stages.length) return;

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      var s = stages.find(function (st) { return st.el === e.target; });
      if (s) { s.active = e.isIntersecting; if (!s.active && s.spot) { s.spot.style.opacity = "0"; s.sOn = false; } }
    });
    kick();
  }, { rootMargin: "18% 0px 18% 0px", threshold: 0 });
  stages.forEach(function (s) { io.observe(s.el); });

  window.addEventListener("resize", function () {
    SMALL = window.matchMedia("(max-width:920px)").matches;
    stages.forEach(function (s) { s.size(); });
  }, { passive: true });

  /* ---------- shared loop ---------- */
  var running = false, raf = 0;
  var REPEL_R = 150 * DPR, REPEL_R2 = REPEL_R * REPEL_R;
  function frame() {
    raf = 0;
    if (document.hidden) { running = false; return; }
    var any = false;
    for (var k = 0; k < stages.length; k++) {
      var s = stages[k];
      if (!s.active) continue;
      any = true;
      var rect = s.el.getBoundingClientRect();
      var mx = (ptr.x - rect.left) * DPR, my = (ptr.y - rect.top) * DPR;
      var inStage = FINE && ptr.x > rect.left && ptr.x < rect.right && ptr.y > rect.top && ptr.y < rect.bottom;
      var force = (0.7 + ptr.speed * 0.08) * INTENSITY;
      s.g.clearRect(0, 0, s.W, s.H);
      for (var i = 0; i < s.parts.length; i++) {
        var p = s.parts[i];
        s.mode.step(p, s.W, s.H);
        if (inStage) {
          var dx = p.x - mx, dy = p.y - my, d2 = dx * dx + dy * dy;
          if (d2 < REPEL_R2 && d2 > 0.01) {
            var d = Math.sqrt(d2), f = (1 - d / REPEL_R) * force;
            p.x += (dx / d) * f * 2.2; p.y += (dy / d) * f * 2.2;
          }
        }
        s.mode.draw(s.g, p);
      }
      if (s.spot) {
        if (inStage) {
          s.sx += ((ptr.x - rect.left) - s.sx) * 0.12;
          s.sy += ((ptr.y - rect.top) - s.sy) * 0.12;
          s.spot.style.transform = "translate3d(" + s.sx.toFixed(1) + "px," + s.sy.toFixed(1) + "px,0)";
          if (!s.sOn) { s.spot.style.opacity = "0.7"; s.sOn = true; }
        } else if (s.sOn) { s.spot.style.opacity = "0"; s.sOn = false; }
      }
    }
    if (any) { raf = requestAnimationFrame(frame); } else { running = false; }
  }
  function kick() { if (!running) { running = true; if (!raf) raf = requestAnimationFrame(frame); } }
  document.addEventListener("visibilitychange", function () { if (!document.hidden) kick(); });
  kick();

  /* theme editor: new sections get atmospheres too */
  document.addEventListener("shopify:section:load", function (e) {
    e.target.querySelectorAll("[data-atmos]").forEach(function (el) { setupStage(el); io.observe(el); });
    kick();
  });
})();
